import { faqItems } from '@/mocks/home';

export default function FaqSection() {
  return (
    <section id="faq" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-700 text-xs font-medium rounded-full mb-4">
            帮助中心
          </span>
          <h2 className="text-2xl md:text-4xl font-heading text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-3">
            关于拷贝漫画的常见疑问，这里都有答案
          </p>
        </div>

        <div className="space-y-4">
          {faqItems.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-50 border border-background-200 rounded-xl p-6"
            >
              <h3 className="text-base font-semibold text-foreground-900 flex items-start gap-3">
                <span className="text-primary-500 flex-shrink-0 mt-0.5">
                  <i className="ri-question-answer-line"></i>
                </span>
                {faq.question}
              </h3>
              <p className="text-sm text-foreground-600 mt-3 leading-relaxed pl-8">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}